module.exports = __webpack_public_path__ + "84aabbec375f4e65c3bdbf3d6b042bca.svg";